import Form from '@utils/form'
import tableSelect from './config/tableSelect'
import http from '@plugin/axios'

function submit(data: any) {
  const info = {
    ...data,
    status: '1',
    list: data.list.map((item: any, index: number) => {
      return {
        id: item.id,
        qualitativeItemId: item.qualitativeItemId,
        qualitativeItemNo: item.qualitativeItemNo,
        weight: item.weight,
        sequenceNum: index + 1
      }
    })
  }
  return http({
    url: '/srmQualitativeFormula/addSrmQualitativeFormula',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: info
  })
}

export default new Form('performance.qualitativeFormula')
  .url(submit)
  .title('formTitle.baseInfo')
  .add('qualitativeFormulaNo').required()
  .add('qualitativeFormulaName').required()
  .add('remarks').merge('textarea')
  .table('list', tableSelect).listRequired()
  .end()
